<ng-container *ngIf="isLoaded; else loading">
  <div class="registration-benefit-options">
    <div class="register-benefit-option-header">
      <h5 class="register-benefit-option-title">{{ 'fgbcl.registration.benefits.options.title' | translate }}</h5>
    </div>
    <p
      class="register-benefit-subtitle"
      [innerHtml]="'fgbcl.registration.benefits.options.subtitle' | translate | markdownTranslate"
    ></p>

    <hr class="divider" />
    <ng-container *ngIf="benefits?.length > 0; else noBenefits">
      <div class="register-benefit-member-details" *ngIf="memberDetails$ | async as memberDetails">
        <label>{{ 'fgbcl.registration.benefits.member.details.label' | translate }} </label>
        <span class="register-benefit-member-name">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</span>
      </div>
      <div class="benefits-container">
        <div class="benefit-item card" *ngFor="let benefit of benefits">
          <div class="img-container">
            <img [src]="benefit.ImageFileName | contentImage : '6'" alt="" />
          </div>
          <div class="benefit-item-body">
            <h5 class="benefit-item-title">{{ benefit.Name }}</h5>
            <p class="benefit-item-desc mb-2" [innerHtml]="benefit.Description"></p>
            <div class="action-wrapper">
              <button
                class="btn btn-primary"
                [class.selected]="benefit.selected"
                (click)="toggleSelect(benefit.BenefitId)"
                [disabled]="isUnlimitedSelections ? null : selectedBenefits?.length >= numOfSelections && !benefit.selected"
              >
                @if (benefit.selected) {
                {{ 'fgbcl.registration.benefits.options.button.selected' | translate }}
                } @else {
                {{ 'fgbcl.registration.benefits.options.button' | translate }}
                }
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr class="divider" />
    </ng-container>
    <ng-template #noBenefits>
      <div class="no-benefits">
        <div class="no-benefits-text">{{ 'fgbcl.registration.benefits.options.no.benefits' | translate }}</div>
      </div>
    </ng-template>

    <div class="error-message text-danger" *ngIf="!isUnlimitedSelections && selectedBenefits?.length > numOfSelections">
      {{ 'fgbcl.registration.benefits.options.exceed.error' | translate : { numOfSelections: numOfSelections } }}
    </div>
    <fgbcl-registration-navigation
      (nextButtonClicked)="submitStep()"
      [stepType]="stepType"
      [nextButtonDisabled]="isUnlimitedSelections ? selectedBenefits?.length === 0 : selectedBenefits?.length < numOfSelections"
    ></fgbcl-registration-navigation>
  </div>
</ng-container>

<ng-template #loading>
  <div class="loading-container">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
